import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';

const AdminIndexActions = {
  folderAction: (_result) => {},

  contentAction: (result) => {
    window.location = AssetPickerTypes.getItemAdminUrl(result);
  },
};

export default AdminIndexActions;
